import { createBoundActions } from '../common/bound-actions'
import { DEFAULT_CONTEXT_PATH } from '../common/constants'

const RESOURCE_KEY = 'environment'

/**
 * Redux action thunk for 'environment' resource
 *
 * @param {string} contextPath - The URL path prefix to be used (Atlantis uses '/api')
 * @param {string} resourcePath - The resource path of the environment REST resource (normally '/environment')
 * @return {Promise}
 */
function createEnvironmentActions(contextPath = DEFAULT_CONTEXT_PATH, resourcePath = '/' + RESOURCE_KEY) {
    return createBoundActions(RESOURCE_KEY, contextPath, resourcePath, null)
}

/**
 * Convenience Redux action thunk for retrieving the 'environment' resource
 *
 * @param {string} pathPrefix - The URL path prefix to be used (Atlantis uses '/api')
 * @param {string} resourcePath - The resource path of the environment REST resource (normally '/environment')
 * @return {Promise}
 */
export function createFetchEnvironmentThunk(pathPrefix = DEFAULT_CONTEXT_PATH, resourcePath = '/' + RESOURCE_KEY) {
    const environmentActions = createEnvironmentActions(pathPrefix, resourcePath)

    return function fetchEnvironment(dispatch) {
        return dispatch(environmentActions.fetch())
    }
}
